import { useEffect, useState } from "react";
import { getValue, getTotal, bTh, sTh, mTh } from "../../../../../helpers/functions/report-table";
import "./dashboard-st-table.css";

export default function Upstreams({ data, getReqPerSec }) {
  const [dataKeys, setDataKeys] = useState([]);

  useEffect(() => {
    sort_obj_keys();
  }, [data]);

  const sort_obj_keys = () => {
    let allKeys = Object.keys(data);
    allKeys.sort();

    const tempData = [];
    allKeys.map((key) => {
      if (key !== "::nogroups") {
        data[key].map((d_key) => {
          tempData.push(d_key);
        });
      }
    });

    setDataKeys(tempData);
  }

  return (
    <>
      <h6 className="table-title pb-2">Upstreams:</h6>

      <div className="report-table-container">
        <table>
          <thead>
          <tr>
            <th rowSpan="2" className="td-sticky">Server</th>
            <th rowSpan="2">State</th>
            <th rowSpan="2">Response Time</th>
            <th rowSpan="2">Weight</th>
            <th rowSpan="2">MaxFails</th>
            <th rowSpan="2">FailTimeout</th>
            <th colSpan="3">Requests</th>
            <th colSpan="6">Responses</th>
            <th colSpan="4">Traffic</th>
          </tr>
          <tr>
            <th>Total</th>
            <th>Req/s</th>
            <th>Time</th>
            <th>1xx</th>
            <th>2xx</th>
            <th>3xx</th>
            <th>4xx</th>
            <th>5xx</th>
            <th>Total</th>
            <th>Sent</th>
            <th>Rcvd</th>
            <th>Sent/s</th>
            <th>Rcvd/s</th>
          </tr>
          </thead>
          <tbody>
          {dataKeys?.map((d, i) => {
            const responses = {
              "1xx": getValue(d, "1xx"),
              "2xx": getValue(d, "2xx"),
              "3xx": getValue(d, "3xx"),
              "4xx": getValue(d, "4xx"),
              "5xx": getValue(d, "5xx")
            }

            return (
               <tr key={`upstream-${i}`}>
                 <th className="td-sticky">{d.server}</th>
                 <td>{sTh(d.backup, d.down)}</td>
                 <td>{mTh(d.responseMsec)}</td>
                 <td>{d.weight}</td>
                 <td>{d.maxFails}</td>
                 <td>{d.failTimeout}</td>
                 <td>{d.requestCounter + d.overCounts["maxIntegerSize"] * d.overCounts["requestCounter"]}</td>
                 <td>{getReqPerSec(`upstream-reqs-${d.server}`, d.requestCounter)}</td>
                 <td>{mTh(d.requestMsec)}</td>
                 <td>{responses["1xx"]}</td>
                 <td>{responses["2xx"]}</td>
                 <td>{responses["3xx"]}</td>
                 <td>{responses["4xx"]}</td>
                 <td>{responses["5xx"]}</td>
                 <td>{getTotal(responses)}</td>
                 <td>{bTh(d.outBytes + d.overCounts["maxIntegerSize"] * d.overCounts["outBytes"])}</td>
                 <td>{bTh(d.inBytes + d.overCounts["maxIntegerSize"] * d.overCounts["inBytes"])}</td>
                 <td>{bTh(getReqPerSec(`upstream-ts-${d.server}`, d.outBytes))}</td>
                 <td>{bTh(getReqPerSec(`upstream-tr-${d.server}`, d.inBytes))}</td>
               </tr>
            )
          })}

          {/*{sortedKeys?.map((key, i) => {*/}
          {/*  if (key !== "::nogroups") {*/}
          {/*    const data_key = data[key];*/}
          {/*    console.log("data_key", data_key)*/}
          {/*    console.log("key", key)*/}

          {/*    data_key?.map((d, j) => {*/}
          {/*      console.log("d", d)*/}
          {/*      const responses = {*/}
          {/*        "1xx": getValue(d, "1xx"),*/}
          {/*        "2xx": getValue(d, "2xx"),*/}
          {/*        "3xx": getValue(d, "3xx"),*/}
          {/*        "4xx": getValue(d, "4xx"),*/}
          {/*        "5xx": getValue(d, "5xx")*/}
          {/*      }*/}

          {/*      console.log("responses", responses)*/}

          {/*      return (*/}
          {/*         <tr key={`upstream-${i}-${j}`}>*/}
          {/*           <th className="td-sticky">{d.server}</th>*/}
          {/*           <td>{sTh(d.backup, d.down)}</td>*/}
          {/*           <td>{mTh(d.responseMsec)}</td>*/}
          {/*           <td>{d.weight}</td>*/}
          {/*           <td>{d.maxFails}</td>*/}
          {/*           <td>{d.failTimeout}</td>*/}
          {/*           <td>{d.requestCounter + d.overCounts["maxIntegerSize"] * d.overCounts["requestCounter"]}</td>*/}
          {/*           <td>{getReqPerSec(`upstream-reqs-${d.server}`, d.requestCounter)}</td>*/}
          {/*           <td>{mTh(d.requestMsec)}</td>*/}
          {/*           <td>{responses["1xx"]}</td>*/}
          {/*           <td>{responses["2xx"]}</td>*/}
          {/*           <td>{responses["3xx"]}</td>*/}
          {/*           <td>{responses["4xx"]}</td>*/}
          {/*           <td>{responses["5xx"]}</td>*/}
          {/*           <td>{getTotal(responses)}</td>*/}
          {/*           <td>{bTh(d.outBytes + d.overCounts["maxIntegerSize"] * d.overCounts["outBytes"])}</td>*/}
          {/*           <td>{bTh(d.inBytes + d.overCounts["maxIntegerSize"] * d.overCounts["inBytes"])}</td>*/}
          {/*           <td>{bTh(getReqPerSec(`upstream-ts-${d.server}`, d.outBytes))}</td>*/}
          {/*           <td>{bTh(getReqPerSec(`upstream-tr-${d.server}`, d.inBytes))}</td>*/}
          {/*         </tr>*/}
          {/*      )*/}
          {/*    });*/}
          {/*  }*/}
          {/*})}*/}
          </tbody>
        </table>
      </div>

    </>
  )
}
